import React, { Component } from 'react';
import { Button, Form , Table, Divider, Spin, Row, Col, Icon, Modal, message } from 'antd';
import { Link } from 'react-router-dom'
import './css/style.css';
import logo from './img/logo.png';
import moment from 'moment'
import _orderBy from 'lodash/orderBy'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import {HeaderContainer, BoxContainer, BoxTableContainer, TableContainer} from '../pages/styled-components/index';

const confirm = Modal.confirm;

class Complete extends Component {
  state={
    event:[]
  }
  componentWillReceiveProps(nextProps) {
    const { events = [] } = nextProps.data
    const orderedEvents = _orderBy(events, ['_id'], ['desc'])
    this.setState({
      event: orderedEvents
    })
  }

    
  deleteEvent =(id , title)=>{
    confirm({
      title: 'Are you sure delete this task?',
      content: `Event "${title}" `,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: () => this.props.removeEvent({
        variables:{
          eventId: id
        }
      }).then(res => {
        message.success('Remove Event of success');
        setTimeout(function(){ window.location.href=`/event`}, 1000);
      }),
      onCancel() {
        // console.log('Cancel');
      },
    });
    // this.props.removeEvent({
    //   variables: {
    //     eventId: id
    //   }
    // }).then(console.log)
  }
    render() {
      if(!this.props.data.events){
        return <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'100vh' }}>
        <Spin tip="Loading..."/>
        </div>
      }   
        const { event } = this.state  
        
        const columns = [{
            title: 'Event',
            dataIndex: 'title',
            key: 'event',
            className:'event',
          }, {
            title: 'Opening Event',
            dataIndex: 'startDate',
            key: 'opening',
            className:'opening',
            render:(startDate)=>{
                const timestart = moment(startDate).format('YYYY-MM-DD HH:mm')
                return timestart
              }
          }, {
            title: 'Closing Event',
            dataIndex: 'endDate',
            key: 'closing',
            className:'closing',
            render:(endDate)=>{
                const timeend = moment(endDate).format('YYYY-MM-DD HH:MM')
                return timeend
            }
          }, {
            title: 'Action',
            key: 'action',
            render: (text, event, index) => (
              <span>
                <a href={`/editEvent/${event._id}`}>
                  <Button type="primary" ><Icon type="edit" size='small'/></Button>
                </a>
                {/* <Divider type="vertical" />
                <a href={`/comprehendEvent/${event._id}`}>
                  <Button className="btn-comprehend" ><Icon type="profile"/></Button>
                </a> */}
                <Divider type="vertical" />
                <a onClick={() => this.deleteEvent(event._id, event.title )}>
                  <Button className="btn-delete" ><Icon type="delete"/></Button>
                </a>
              </span>
            ),
          }];   
        return (
              <div>
                <Row>
                    <Col style={{marginTop:'100px'}} /> 
                    <Col className="header">
                        <HeaderContainer>
                            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-start'}}>
                                <img src={logo} alt="logo" />
                                <a href="/event" className='backhome'>
                                  <strong>Event</strong>
                                </a>
                                <a href="/comprehendEvent" className='backhome'>
                                  <strong>Report</strong>
                                </a>
                            </div> 
                        </HeaderContainer>   
                    </Col>
                </Row>
                <BoxContainer>
                  <div style={{display:'flex', width:'90%' }}>
                    <Link to={`/createEvent`} >
                      <Button className="btn-add"><Icon type="plus-circle"/>Create Event</Button>
                    </Link>  
                    {/* <Link style={{ marginLeft:'10px' }} to={`/comprehendEvent`} >
                      <Button className="btn-comprehend"><Icon type="profile"/>All Event summary</Button>
                    </Link>   */}
                  </div>
                </BoxContainer>
                <BoxTableContainer>
                  <TableContainer>
                    <Table rowKey='_id' columns={columns} dataSource={event} pagination={{ pageSize: 50 }}/> 
                  </TableContainer>
                </BoxTableContainer>
              </div>
    );
  }
}

// export default (Complete);
const queryevents = gql`
  query queryevents{
    events {
      _id
      slug
      thumbnailUrl
      title
      startDate
      endDate
      sumDistance
      modalContent
      donationAllshirt
      donationBykilo
    }
  }`

const removeEventMutation = gql`
  mutation removeEvent($eventId: MongoID!){
    removeEvent(_id: $eventId){
      record{
        title
      }
    }
  }`

export default compose(
    Form.create() ,
    graphql(queryevents),
    graphql(removeEventMutation,{
      name: 'removeEvent',     
      }
    ),
  )(Complete);



// WEBPACK FOOTER //
// ./src/components/pages/complete.js